import api from './client'
import {  postParams } from '../lib/useParams'

export const getSearch = async (prm) => {
  // return api.get('search/getSearch', { params: { P_REQUEST: getParams(prm) } }).then(result => {
  //   return result.data
  // })
  return api.post('search/getSearch', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result.data
  })
}
